import { F0Box, F0Dialog, F0Text } from '@factorialco/f0-react'
import {
  IncentivesBulkDeleteCompensationPlanAssignmentDocument,
  IncentivesCompensationPlanDetailDocument,
  IncentivesCompensationPlanPayoutsDocument,
} from 'generated/resources/graphql'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import { useMutation } from 'modules/core/hooks/useMutation'
import app from 'modules/core/store/models/app'

interface RemoveAssignmentDialogProps {
  isOpen: boolean
  onClose: () => void
  assignmentId: string
}

export function RemoveAssignmentDialog({
  isOpen,
  onClose,
  assignmentId,
}: RemoveAssignmentDialogProps) {
  const [deleteAssignment, { loading }] = useMutation(
    IncentivesBulkDeleteCompensationPlanAssignmentDocument,
    {
      extractorFn: (data) =>
        data.incentivesMutations.bulkDeleteIncentivesCompensationPlanAssignment,
      refetchQueries: [
        IncentivesCompensationPlanPayoutsDocument,
        IncentivesCompensationPlanDetailDocument,
      ],
      awaitRefetchQueries: true,
    }
  )

  const handleConfirm = async () => {
    const result = await deleteAssignment({
      variables: { ids: [assignmentId] },
    })

    const handled = handleResult(result, () =>
      app.setFlash({
        type: 'wrong',
        message: i18n.t(
          'incentives.detail.assignments.remove_additional_compensation.error_message'
        ),
      })
    )

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
      onClose()
    }
  }

  return (
    <F0Dialog
      isOpen={isOpen}
      title={i18n.t('incentives.detail.assignments.remove_additional_compensation.modal_title')}
      onClose={onClose}
      width="sm"
      primaryAction={{
        label: i18n.t('incentives.detail.assignments.remove_additional_compensation.modal_confirm'),
        onClick: handleConfirm,
        loading,
        variant: 'critical',
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: onClose,
      }}
    >
      <F0Box display="flex" flexDirection="column" gap="md">
        <F0Text
          content={i18n.t(
            'incentives.detail.assignments.remove_additional_compensation.modal_body'
          )}
        />
      </F0Box>
    </F0Dialog>
  )
}
